import { getAnyFromLocalizationMap } from '../../utility/lang-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import {
  cloneMap,
  DataModel,
  DataModelBuilder,
  isSameMap,
  mapToData,
  SerializationContext,
  SerializedData,
} from '../dto/dto.js';
import { Language } from './language.js';
import { PhotoReference } from './file-reference/photo-reference.js';

export class LocalizedPhotoReference extends DataModel {
  static readonly TYPE_ID: string = '5d4f1eff83bd441b853e4ca0aaaf94b0';

  constructor(
    private readonly localizedPhoto: Map<Language, PhotoReference>,
  ) {
    super();
  }

  get $typeId() {
    return LocalizedPhotoReference.TYPE_ID;
  }

  get isEmpty(): boolean {
    return !this.isNotEmpty;
  }

  get isNotEmpty(): boolean {
    return this.localizedPhoto.size > 0;
  }

  static empty(): LocalizedPhotoReference {
    return new LocalizedPhotoReference(new Map<Language, PhotoReference>());
  }

  get(language: Language): PhotoReference | null {
    return this.localizedPhoto.get(language) ?? null;
  }

  getAny(language: Language | null = null): PhotoReference | null {
    return getAnyFromLocalizationMap(this.localizedPhoto, language);
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocalizedPhotoReference {
    return new LocalizedPhotoReference(
        MapUtils.getMap(map, 'localizedPhoto', (k, v) => {
          return { key: <Language>k, value: context.fromData<PhotoReference>(v as SerializedData) };
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'localizedPhoto': mapToData<Language, PhotoReference>(this.localizedPhoto, (k, v) => {
        return { key: k.toString(), value: context.toData(v) };
      }),
    };
  }

  clone(): this {
    return new LocalizedPhotoReference(
        cloneMap<Language, PhotoReference>(this.localizedPhoto)
    ) as this;
  }

  isSame(other: LocalizedPhotoReference): boolean {
    if(other === this) {
      return true;
    }

    return isSameMap<Language, PhotoReference>(other.localizedPhoto, this.localizedPhoto);
  }
}

export class LocalizedPhotoReferenceBuilder extends DataModelBuilder<LocalizedPhotoReference> {
  build(context: SerializationContext, map: SerializedData): LocalizedPhotoReference {
    return LocalizedPhotoReference.fromMap(context, map);
  }
}
